export const site = {
  name: "Arnold Gartenpflege",
  owner: "Arnold Szaniszlo",
  claim: "Gartenpflege · Baumpflege · Winterdienst",
  phoneDisplay: "0160 9860 3744",
  phoneHref: "tel:+4916098603744",
  email: "info@arnoldgartenpflege.de",
  emailHref: "mailto:info@arnoldgartenpflege.de",
  street: "Lederhosenstraße 31",
  city: "91341 Röttenbach",
  cityShort: "Röttenbach",
  instagram: "https://www.instagram.com/arnoldgartenpflege.de/",
  hours: [
    { day: "Montag – Freitag", time: "08:00 – 17:00 Uhr" },
    { day: "Samstag", time: "09:00 – 15:00 Uhr" },
    { day: "Sonntag", time: "geschlossen" },
  ],
  rating: "5,0",
  region: "Erlangen, Nürnberg, Fürth, Forchheim und Herzogenaurach",
  cities: ["Erlangen", "Nürnberg", "Fürth", "Forchheim", "Herzogenaurach"],
  logo: "https://storage.helloreaddy.io/project_files/0469b4b9-4faa-42c6-9db9-282aa399951a/148f9e97-2003-4e01-9cf4-0144ca49c336_compressed_424FF621-9F30-4EF7-9E70-1E3785037FC5.webp",
};

export const nav = [
  { id: "leistungen", label: "Leistungen" },
  { id: "gewerbe", label: "Gewerbe" },
  { id: "projekte", label: "Projekte" },
  { id: "bewertungen", label: "Bewertungen" },
  { id: "kontakt", label: "Kontakt" },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Professional%20realistic%20photograph%20of%20a%20cozy%20idyllic%20private%20garden%20at%20dusk%20with%20warm%20glowing%20string%20lights%20strung%20between%20trees%20and%20shrubs%2C%20lush%20green%20lawn%2C%20softly%20lit%20flower%20beds%2C%20natural%20stone%20path%2C%20wooden%20garden%20seating%20corner%2C%20warm%20golden%20ambient%20glow%2C%20calm%20inviting%20authentic%20residential%20atmosphere%2C%20natural%20colours%2C%20high%20detail%2C%20no%20people&width=2560&height=1440&seq=hero-cozy-garden-2026-d2&orientation=landscape&nocache=true";